import { formatCurrency } from '../../../util/currency';
const priceIncreaseFormSelector = '.js-price_increase_form';
const percentageButtonSelector = '.js-price_increase_percentage_button';
const priceIncreaseAmountSelector = '.js-price_increase_amount';
const monthlyAmountUnitInputSelector = '.js-price_increase_monthly_amount_unit';
const monthlyAmountSubunitInputSelector = '.js-price_increase_monthly_amount_subunit';
const annualAmountUnitInputSelector = '.js-price_increase_annual_amount_unit';
const annualAmountSubunitInputSelector = '.js-price_increase_annual_amount_subunit';
const previousMonthlyAmountUnitInputSelector = '.js-price_increase_previous_monthly_amount_unit';
const previousMonthlyAmountSubunitInputSelector = '.js-price_increase_previous_monthly_amount_subunit';
const previousAnnualAmountUnitInputSelector = '.js-price_increase_previous_annual_amount_unit';
const previousAnnualAmountSubunitInputSelector = '.js-price_increase_previous_annual_amount_subunit';
window.up.compiler(priceIncreaseFormSelector, (form) => {
    const priceIncreaseAmountSpan = document.querySelector(priceIncreaseAmountSelector);
    const buttons = form.querySelectorAll(percentageButtonSelector);
    const monthlyAmountUnitInput = form.querySelector(monthlyAmountUnitInputSelector);
    const monthlyAmountSubunitInput = form.querySelector(monthlyAmountSubunitInputSelector);
    const annualAmountUnitInput = form.querySelector(annualAmountUnitInputSelector);
    const annualAmountSubunitInput = form.querySelector(annualAmountSubunitInputSelector);
    const previousMonthlyAmountUnitInput = form.querySelector(previousMonthlyAmountUnitInputSelector);
    const previousMonthlyAmountSubunitInput = form.querySelector(previousMonthlyAmountSubunitInputSelector);
    const previousAnnualAmountUnitInput = form.querySelector(previousAnnualAmountUnitInputSelector);
    const previousAnnualAmountSubunitInput = form.querySelector(previousAnnualAmountSubunitInputSelector);
    const displayTotalIncreaseAmount = () => {
        if (priceIncreaseAmountSpan) {
            const monthlyCount = Number(priceIncreaseAmountSpan.dataset.monthlyCount);
            const annualCount = Number(priceIncreaseAmountSpan.dataset.annualCount);
            const monthlyIncreaseUnit = Number(monthlyAmountUnitInput === null || monthlyAmountUnitInput === void 0 ? void 0 : monthlyAmountUnitInput.value) - Number(previousMonthlyAmountUnitInput === null || previousMonthlyAmountUnitInput === void 0 ? void 0 : previousMonthlyAmountUnitInput.value);
            const monthlyIncreaseSubunit = Number(monthlyAmountSubunitInput === null || monthlyAmountSubunitInput === void 0 ? void 0 : monthlyAmountSubunitInput.value) - Number(previousMonthlyAmountSubunitInput === null || previousMonthlyAmountSubunitInput === void 0 ? void 0 : previousMonthlyAmountSubunitInput.value);
            const annualIncreaseUnit = Number(annualAmountUnitInput === null || annualAmountUnitInput === void 0 ? void 0 : annualAmountUnitInput.value) - Number(previousAnnualAmountUnitInput === null || previousAnnualAmountUnitInput === void 0 ? void 0 : previousAnnualAmountUnitInput.value);
            const annualIncreaseSubunit = Number(annualAmountSubunitInput === null || annualAmountSubunitInput === void 0 ? void 0 : annualAmountSubunitInput.value) - Number(previousAnnualAmountSubunitInput === null || previousAnnualAmountSubunitInput === void 0 ? void 0 : previousAnnualAmountSubunitInput.value);
            const monthlyIncrease = (monthlyIncreaseUnit + monthlyIncreaseSubunit / 100) * monthlyCount;
            const annualIncrease = (annualIncreaseUnit + annualIncreaseSubunit / 100) * annualCount;
            const totalIncrease = monthlyIncrease + annualIncrease || 0;
            priceIncreaseAmountSpan.textContent = formatCurrency(totalIncrease, priceIncreaseAmountSpan.dataset.currency);
        }
    };
    displayTotalIncreaseAmount();
    window.up.on(form, 'change', undefined, () => {
        buttons.forEach(button => {
            button.setAttribute('aria-checked', 'false');
        });
        displayTotalIncreaseAmount();
    });
    buttons.forEach(button => {
        window.up.on(button, 'click', undefined, () => {
            button.setAttribute('aria-checked', 'true');
            buttons.forEach(otherButton => {
                if (otherButton !== button) {
                    otherButton.setAttribute('aria-checked', 'false');
                }
            });
            if (monthlyAmountUnitInput && monthlyAmountSubunitInput && annualAmountUnitInput && annualAmountSubunitInput) {
                monthlyAmountUnitInput.value = button.dataset.monthlyAmountUnit || '0';
                monthlyAmountSubunitInput.value = button.dataset.monthlyAmountSubunit || '0';
                annualAmountUnitInput.value = button.dataset.annualAmountUnit || '0';
                annualAmountSubunitInput.value = button.dataset.annualAmountSubunit || '0';
            }
            displayTotalIncreaseAmount();
        });
    });
});
